import { CamposGenericos } from './camposGenericos';

export class Cuenta extends CamposGenericos {
    calleNro: string;
    ciudad: string;
    clienteBloq: string;
    codigoPostal: string;
    condicionPago: string;
    crblb: string;
    creditoUtilizado: number;
    creditoVencido: boolean;
    cuit: string;
    dbekr: number;
    fechaActualizacion: Date;
    fechaUsoCupon: Date;
    fechaVtoCredito: string;
    grupoCliente: string;
    idCompania: string;
    idCondicionPago: string;
    idCupon: string;
    idDivision: string;
    idGrupoCliente: string;
    idGrupoCuentaCliente: string;
    idMoneda: string;
    idPais: string;
    idRegion: string;
    idSalesOffice: string;
    idSalesOrg: string;
    idTaxClassification: string;
    idTipoCliente: string;
    idTipoCredito: string;
    idZonaVendedor: string;
    limiteCredito: number;
    mensajeBloqueo: string;
    mensajeStatus: string;
    nombre: string;
    nroCliente: string;
    provincia: string;
    region: string;
    sitioInternet: string;
    status: string;
    taxClassification: string;
    telefono: string;
    tipoCredito: string;
    usuarioRedCupon: string;
    usuarioRedUltimaActualizacion: string;
    zonaVendedor: string;
    email: string;
    emailOpcional: string;
    displayValue2: string;
}